
import Axios from "./axios.service";
const axiosInstance = new Axios();
const API_URL = process.env.VUE_APP_API_BASE_URL + '/';

export async function getVipData() {
    const url = API_URL+ "desconto-vip";
    return await axiosInstance.useAxios('get', url);
}
export async function getAuth() {
    const url = API_URL+ "auth";
    return await axiosInstance.useAxios('get', url);
}
